import { ace_hooks } from '@axo/shared/data-access/hooks';

export function useSetAgentAvailabilityV3(agentId: string) {
  const setAvailable = ace_hooks.useSetAgentAvailableV3();
  const setUnavailable = ace_hooks.useSetAgentUnavailableV3();

  const setAgentAvailabilityV3 = async (available: boolean) => {
    if (available) {
      await setAvailable.mutateAsync({ AgentID: agentId });
    } else {
      await setUnavailable.mutateAsync({ AgentID: agentId });
    }
  };

  return {
    setAgentAvailabilityV3,
    isLoading: setAvailable.isLoading || setUnavailable.isLoading,
  };
}
